import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { onUnauthorized } from '../../../lib/api-client';
import { rememberTarget } from '../../../lib/postLogin';

/**
 * Registers a global 401 handler on mount. On any 401 response from the API, redirects to
 * /login?reason=security, carrying the current page in `next` (and in sessionStorage, see
 * lib/postLogin) so sign-in returns to it.
 */
export function ForceSignOutHandler() {
  const navigate = useNavigate();

  useEffect(() => {
    return onUnauthorized(() => {
      // Several queries fail at once; a second call from /login would replace the URL carrying next.
      if (window.location.pathname === '/login') {
        return;
      }
      // Read at call time: the handler is registered once and outlives every navigation.
      const { pathname, search, hash } = window.location;
      const target = rememberTarget(`${pathname}${search}${hash}`);
      const next = target === null ? '' : `&next=${encodeURIComponent(target)}`;
      navigate(`/login?reason=security${next}`, { replace: true });
    });
  }, [navigate]);

  return null;
}
